"use strict";

// Pass nonce from executing script element.
__webpack_nonce__ = document.currentScript?.nonce;
if (!__webpack_nonce__) {
  console.warn(`⚠️ No nonce provided to webpack.`);
}
const tryHydrateReactComponents = async () => {
  // Initialise React if there are any React components.
  if (!document.querySelector('react-component')) {
    console.warn(`No React components found to hydrate.`);
    return;
  }
  const [React, ReactDOM, components] = await Promise.all([import(/* webpackChunkName: "react-core" */'react'), import(/* webpackChunkName: "react-dom" */'react-dom/client'), import(/* webpackChunkName: "components" */'@/components')]);
  window.React = React.default;
  // @ts-expect-error ReactDOM type mismatch, can be ignored safely.
  window.ReactDOM = ReactDOM;
  window.Components = components.default;
  if ('ReactJsAsyncInit' in window && typeof window.ReactJsAsyncInit === 'function') {
    console.log(`Hydrating React components.`);
    window.ReactJsAsyncInit();
  }
};
tryHydrateReactComponents();